import xtend from 'xtend';
import stateTool from '@nichoth/state';
const createStore = stateTool.extend
import List from '@nichoth/state/list';
import _ from 'underscore'

var _metaStores = [
    { name: 'Keywords', idKey: 'keywordID', sortBy: 'keyword' },
    { name: 'Locations', idKey: 'locationID', sortBy: 'locationName' },
    { name: 'Technicians', idKey: 'techID', sortBy: 'techName' },
    { name: 'Encoders', idKey: 'encoderID', sortBy: 'simpleName' },
    { name: 'Metamarkers', idKey: 'markerID', sortBy: 'start' },
    { name: 'FacebookLive', idKey: 'facebookLiveID', sortBy: 'facebookLiveID' },
    // { name: 'StreamTargetProviders', idKey: 'altProviderID', sortBy: 'altProviderName' }
];

var metaStores = _metaStores.reduce(function (acc, data) {
    acc[data.name] = createStore({
        idKey: data.idKey,
        sortBy: data.sortBy
    }, List);
    return acc;
}, {});

// patch this because the keywords are not sorted alphabetically from
// the api
var _keywordsGet = metaStores.Keywords.prototype.get
metaStores.Keywords.prototype.get = function (keywords) {
    var sorted = _.sortBy(keywords, k => k.keyword.toLowerCase())
    return _keywordsGet.call(this, sorted)
}

var Categories = List.extend({
    idKey: 'categoryID',
    sortBy: 'categoryName',
    _state: xtend(List.prototype._state, {
        nested: {}
    }),

    get: function (cats) {
        // response has null value if the client has no categories
        cats = cats || []

        this._state.nested = cats
            .filter(cat => cat.parentCategoryID)
            .reduce(function (acc, cat) {
                var newData = {}; newData[cat.categoryID] = cat;
                acc[cat.parentCategoryID] =
                    xtend(acc[cat.parentCategoryID] || {}, newData);
                return acc;
            }, {})
        ;

        return List.prototype.get.call(this, cats);
    },

    add: function (cat) {
        if (cat.parentCategoryID) {
            var data = {}; data[cat.parentCategoryID] = cat;
            this._state.nested[cat.parentCategoryID] =
                xtend(this.state.nested[cat.parentCategoryID] || {}, data);
        }
        return List.prototype.add.apply(this, arguments);
    },

    edit: function (cat) {
        if (cat.parentCategoryID) {
            var data = {}; data[cat.parentCategoryID] = cat;
            this._state.nested[cat.parentCategoryID] =
                xtend(this.state.nested[cat.parentCategoryID] || {}, data);
        }
        return List.prototype.edit.apply(this, arguments);
    },

    delete: function (cat) {
        if (cat.parentCategoryID) {
            delete this._state.nested[cat.parentCategoryID][cat.categoryID];
        }

        // if this is a parent
        // @TODO probably need to set childrens' parent id to null
        if (this._state.nested[cat.categoryID]) {
            delete this._state.nested[cat.categoryID];
        }

        return List.prototype.delete.apply(this, arguments);
    }
});

metaStores.Categories = Categories;
export default metaStores;
